export const translations = {
  en: {
    logout: "Logout",
    refreshData: "Refresh Data",
    refreshPage: "Refresh Page",
    home: "Home",
    hoursToStaySignedIn: "Hours to Stay Signed in",
    dataLastSynced: "Data Last Synced",
    online: "Online",
    offline: "Offline",
    newDailyFieldReport: "T&M Ticket",
    drafts: "Drafts",
    pendingSubmissions: "Pending Submissions",
    submissions: "Last 30 Days Submissions",
    settings: "Settings",
    pending: "Pending",
    history: "History",
    view: "View",
    date: "Date",
    jobNumber: "Job Number",
    followUp: "Follow Up Instructions",
    // workOrderNumber: "Work Order Number",
    refreshing: "Refreshing...",
    notes: "Description of Work",
    job: "Job",
    workOrderNum: "Work Order #",
    rainedOut: "Rained Out",
    street1: "Street 1",
    street2: "Street 2",
    city: "City",
    state: "State",
    postalCode: "Postal Code",
    location: "Location",
    laborAndEquipment: "Labor and Equipment",
    employee: "Employee",
    position: "Position",
    driver: "Truck",
    startTime: "Start Time",
    endTime: "End Time",
    add: "Add",
    rows: "rows",
    laborLineItems: "Labor Line Items",
    standardEquipment: "Standard Equipment",
    equipment: "Equipment",
    quantity: "Quantity",
    additionalEquipment: "Additional Equipment",
    signOff: "Sign Off",
    foremanName: "Foreman Name",
    foremanSignature: "Foreman Signature",
    inspectorName: "Customer Name",
    inspectorSignature: "Customer Signature",
    getSignature: "Get Signature",
    cancel: "Cancel",
    clearSignature: "Clear Signature",
    saveSignature: "Save Signature",
    submit: "Submit",
    jobLocation: "Job Location",
    unsubmit: "Unsubmit",
    confirmLogout:
      "Are you sure you would like to logout?\n\nYou are not able to log back in without an internet connection.",
    clear: "Clear",
    version: "Version",
    earnCode: "Earn Code",
    overtime: "Overtime",
    regular: "Regular",
    doubleTime: "Double Time",
    hours: "Hours",
  },
  es: {
    hours: "Horas",
    logout: "Cerrar sesión",
    refreshData: "Actualizar datos",
    refreshPage: "Actualizar página",
    home: "Inicio",
    hoursToStaySignedIn: "Horas para permanecer conectado",
    dataLastSynced: "Datos sincronizados por última vez",
    online: "En línea",
    offline: "Sin conexión",
    newDailyFieldReport: "Nueva orden de trabajo",
    drafts: "Borradores",
    pendingSubmissions: "Envíos pendientes",
    submissions: "Envíos de los Últimos 30 Días",
    settings: "Configuraciones",
    pending: "Pendiente",
    history: "Historial",
    view: "Ver",
    date: "Fecha",
    jobNumber: "Número de trabajo",
    notes: "Descripción del trabajo",
    job: "Trabajo",
    workOrderNum: "Orden de trabajo #",
    rainedOut: "Suspendido por lluvia",
    street1: "Calle 1",
    street2: "Calle 2",
    city: "Ciudad",
    state: "Estado",
    postalCode: "Código postal",
    location: "Ubicación",
    laborAndEquipment: "Mano de obra y equipo",
    employee: "Empleado",
    position: "Posición",
    driver: "Conductor",
    startTime: "Hora de inicio",
    endTime: "Hora de fin",
    add: "Añadir",
    rows: "filas",
    laborLineItems: "Elementos de línea de mano de obra",
    standardEquipment: "Equipo estándar",
    equipment: "Equipo",
    quantity: "Cantidad",
    additionalEquipment: "Equipo adicional",
    signOff: "Firmar",
    foremanName: "Nombre del capataz",
    foremanSignature: "Firma del capataz",
    inspectorName: "Nombre del inspector",
    inspectorSignature: "Firma del inspector",
    getSignature: "Obtener firma",
    cancel: "Cancelar",
    clearSignature: "Borrar firma",
    saveSignature: "Guardar firma",
    submit: "Enviar",
    jobLocation: "Ubicación del trabajo",
    unsubmit: "Desenviar",
    confirmLogout:
      "¿Está seguro de que desea cerrar sesión?\n\nNo podrá volver a iniciar sesión sin una conexión a Internet.",
    clear: "Borrar",
    followUp: "Instrucciones de seguimiento",
    version: "Versión",
    earnCode: "Código de ganancia",
    regular: "Regular",
    overtime: "Horas extras",
    doubleTime: "Horas dobles",
    refreshing: "Actualizando...",
  },
};
